import { post } from "@/utils/request";

const baseUrl = process.env.config.RRDH_HOST;
export default {
  getList: query => post(baseUrl + "/rrbi/tagsfront/getList", query),

  getBackList: query => post(baseUrl + '/rrbi/tags/getList',query),
  getlistbyprotype: type =>
    post(baseUrl + "/rrbi/tagsfront/getListByProType/" + type),

  getOne: id => post(baseUrl + "/rrbi/tags/getOne?id=" + id),

  getTagList: query => post(baseUrl + "/rrbi/v2/belong/getTagList", query),
};
